// extracted by mini-css-extract-plugin
export default {"container":"styles_container__KwEl3","icon":"styles_icon__B1XJf","code":"styles_code__5x0gc"};